/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import SafeLink from "components/commons/SafeLink";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

import {
  container
} from "../common";
import {GetStartedModal} from "components/commons";

const googlePlayIcon = `${WealthyEnv.BROKING_CDN_URL}/play-store-icon-hq.png`;
const appStoreIcon = `${WealthyEnv.BROKING_CDN_URL}/app-store-icon-hq.png`;

const propTypes = {
  rCode: PropTypes.string,
  setToggleModal: PropTypes.func,
  toggleModal: PropTypes.bool
};

const BrokingBannerCta = ({
  rCode,
  setToggleModal,
  toggleModal
}) => {
  return (
    <>
      <BannerContainer>
        <BackgroundCircle1 />
        <BackgroundCircle2 />
        <BannerCtaWrapper>
          <BannerContent>
            <Tagline>
              Start your investment journey with Wealthy today!
            </Tagline>
            <HelpingLine>
              Value Packed Pricing. No Hidden Charges
            </HelpingLine>
            <CtaButton type="button" onClick={() => setToggleModal(!toggleModal)}>
              Get Started
            </CtaButton>
          </BannerContent>
          <AppDownloadWrapper>
            <DownloadTitle>
              Download the app
            </DownloadTitle>
            <DownloadLinks>
              <LinkItem
                href={WealthyEnv.APP_STORE_DOWNLOAD_LINK}
                rel="noopener noreferrer"
                target="_blank"
              >
                <LinkImage
                  alt="app-store"
                  src={appStoreIcon}
                />
              </LinkItem>
              <LinkItem
                href={WealthyEnv.PLAY_STORE_DOWNLOAD_LINK}
                rel="noopener noreferrer"
                target="_blank"
              >
                <LinkImage
                  alt="app-store"
                  src={googlePlayIcon}
                />
              </LinkItem>
            </DownloadLinks>
          </AppDownloadWrapper>
        </BannerCtaWrapper>
      </BannerContainer>
      <GetStartedModal
        rCode={rCode}
        setToggleModal={setToggleModal}
        toggleModal={toggleModal}
      />
    </>
  );
};

const BannerContainer = styled(container)`
  margin: 10rem auto;
  position: relative;
  overflow: hidden;
  border-radius: 24px;

  @media (max-width: 1220px) {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  @media (max-width: 576px) {
    margin: 5.2rem auto;
    margin-left: 2rem;
    margin-right: 2rem;
    padding-left: 0;
    padding-right: 0;
  }
`;

const BannerCtaWrapper = styled.div`
  padding: 6.6rem 10rem;
  display: flex;
  align-items: center;

  @media (max-width: 576px) {
    display: block;
    padding: 3.4rem 3rem;
  }
`;

const BannerContent = styled.div`
  
`;

const Tagline = styled.h2`
  font-family: 'Marcellus', serif;
  font-size: 4.4rem;
  padding-right: 10rem;
  font-weight: 400;
  line-height: 1.4;

  @media (max-width: 576px) {
    font-size: 2.4rem;
    padding-right: 0;
  }
`;

const HelpingLine = styled.p`
  font-size: 2rem;
  padding-top: 2.3rem;
  color: ${colors.textGray};

  @media (max-width: 576px) {
    font-size: 1.4rem;
    padding-top: 1.6rem;
  }
`;

const CtaButton = styled.button`
  font-size: 1.8rem;
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 1.7rem 4.4rem;
  display: inline-block;
  margin-top: 3.8rem;
  border: none;
  border-radius: 100px;
  min-width: 240px;
  text-align: center;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    transform: translateY(-4px);
  }

  @media (max-width: 576px) {
    font-size: 1.6rem;
    display: block;
    text-align: center;
    margin-top: 2.4rem;
  }
`;

const AppDownloadWrapper = styled.div`
  text-align: center;
  width: fit-content;
  margin-left: auto;
  flex-shrink: 0;

  @media (max-width: 576px) {
    margin: auto;
    margin-top: 4.4rem;
  }
`;

const DownloadTitle = styled.h3`
  font-size: 2.4rem;

  @media (max-width: 576px) { 
    font-size: 1.4rem;
  }
`;

const DownloadLinks = styled.div`

`;

const LinkItem = styled(SafeLink)`
  display: block;
  margin: 0 auto;
  margin-top: 1.6rem;
  width: 25rem;

  @media (max-width: 576px) {
    width: 15rem;
    margin-top: 1rem;
  }
`;

const LinkImage = styled.img`
  border-radius: 6px;
  width: 100%;
`;

const BackgroundCircle1 = styled.div`
  position: absolute;
  top: -61px;
  left: -114px;
  width: 667px;
  height: 667px;
  border-radius: 100%;
  opacity: 0.15;
  background: #D8318C;
  filter: blur(67px);
  pointer-events: none;
  z-index: -1;

  @media (max-width: 576px) {
    left: -380px;
  }
`;

const BackgroundCircle2 = styled.div`
  position: absolute;
  top: -166px;
  right: -114px;
  width: 620px;
  height: 619px;
  border-radius: 100%;
  opacity: 0.15;
  background: #002C96;
  filter: blur(135px);
  pointer-events: none;
  z-index: -1;

  @media (max-width: 576px) {
    right: -480px;
  }
`;

BrokingBannerCta.propTypes = propTypes;

export default BrokingBannerCta;
